import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'
import state from './state'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

// 单例
export default new Vuex.Store({
  actions,
  getters,
  mutations,
  state,
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js